import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { editScrapRecord, createScrapRecord, fetchInventoryScrap, fetchScrapRecordDetail } from '../../actions/scrapRecords_actions';
import { fetchInventories } from '../../actions/inventories_actions';
import { fetchProducts } from '../../actions/products_actions';

import ScrapRecordForm from '../../components/Inventories/scrapRecordForm';

const validate = values => {
  const errors = {}
  if (!values.Name) {
      errors.Name = 'Required'
  }
  return errors
}

let scrapRecordForm = reduxForm({
    form: 'scrapRecordForm',
    validate
})(ScrapRecordForm);

const selector = formValueSelector('scrapRecordForm')

function mapStateToProps(state) {
    const quantityValue = selector(state, 'Quantity');
    const productValue = selector(state, 'ProductNum');
    return {
        quantityValue,
        productValue,

        currentScrapRecord: state.scrapRecords.currentScrapRecord,
        currentScrapRecordDetail: state.scrapRecords.currentScrapRecordDetail,
        detailIsLoading: state.scrapRecords.detailIsLoading,
        detailError: state.scrapRecords.detailError,
        isCreating: state.scrapRecords.isCreating,
        createError: state.scrapRecords.createError,
        created: state.scrapRecords.created,
        isEditing: state.scrapRecords.isEditing,
        editError: state.scrapRecords.editError,
        edited: state.scrapRecords.edited,

        inventories: state.inventories.all,
        vendorIsLoading: state.inventories.isLoading,
        vendorError: state.inventories.error,

        scrapRecordsInventories: state.scrapRecords.inventories,
        inventoriesIsLoading: state.scrapRecords.inventoriesIsLoading,
        inventoriesError: state.scrapRecords.inventoriesError,
        products: state.products.all,
        userPermissions: state.auth.userPermissions
    }
}

export default connect(mapStateToProps, { editScrapRecord, createScrapRecord, fetchProducts, fetchInventoryScrap, fetchScrapRecordDetail, fetchInventories })(scrapRecordForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/scrapRecordForm.jsx